import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import { deleteEntry } from "../../api/commands/entries";
import { getWeek, skipCard, swapCard } from "../../api/commands/keepInTouch";
import {
	addRecord,
	deleteRecord,
	getRecords,
	getSearch,
	mergeRecords,
} from "../../api/commands/records";
import { ApiError } from "../../api/errors";
import { RecordType } from "../../api/schemas/common";
import { Entry } from "../../api/schemas/entries";
import * as AddEntry from "../../widgets/addEntry";
import * as Attributes from "../../widgets/attributes";
import { Dialog } from "../../widgets/dialog";
import * as Cards from "../../widgets/keepInTouchCards";
import * as Picker from "../../widgets/recordPicker";
import * as Tags from "../../widgets/tags";
import { EntryFilter, SearchType } from "./model";

export const Message = defineMessageUnion({
	ChangedSearchText: { value: S.String },
	SearchDebounced: { text: S.String },
	CompletedSyncQuery: {},
	ChangedSearchType: { value: SearchType },
	ChangedEntryType: { value: EntryFilter },
	CompletedSearch: {
		search: S.String,
		cursor: S.Number,
		searchType: S.NullOr(S.String),
		knotType: S.NullOr(S.String),
		tags: S.Array(S.String),
		asOf: S.Option(S.String),
		generation: S.Number,
		result: getSearch.Result,
	},
	CompletedFetchRecords: {
		search: S.String,
		cursor: S.Number,
		asOf: S.Option(S.String),
		generation: S.Number,
		result: getRecords.Result,
	},
	ClickedLoadMore: {},
	ToggledSelect: { id: S.String, selected: S.Boolean },
	ToggledSelectAll: { selected: S.Boolean },
	ClickedDelete: {},
	ClickedConfirmDelete: {},
	GotDeleteDialogMessage: { message: Dialog.Message },
	CompletedDeleteRecord: {
		nodeId: S.String,
		generation: S.Number,
		result: deleteRecord.Result,
	},
	CompletedDeleteEntry: {
		knotId: S.String,
		generation: S.Number,
		result: deleteEntry.Result,
	},
	ClickedMerge: {},
	CompletedMerge: {
		targetNodeId: S.String,
		sourceNodeId: S.String,
		generation: S.Number,
		result: mergeRecords.Result,
	},
	ClickedAddRecord: {},
	GotAddDialogMessage: { message: Dialog.Message },
	ChangedName: { value: S.String },
	ChangedRecordType: { value: RecordType },
	ChangedSubtitle: { value: S.String },
	ChangedEmail: { value: S.String },
	ChangedDescription: { value: S.String },
	GotTagsMessage: { message: Tags.Message },
	ClickedRemoveTag: { tag: S.String },
	GotAttributesMessage: { message: Attributes.Message },
	ClickedDismissError: {},
	SubmittedAddRecord: {},
	CompletedAddRecord: { generation: S.Number, result: addRecord.Result },
	CompletedFetchWeek: {
		asOf: S.Option(S.String),
		generation: S.Number,
		result: getWeek.Result,
	},
	GotCardMessage: { message: Cards.Message },
	CompletedSkip: {
		recordId: S.String,
		generation: S.Number,
		result: skipCard.Result,
	},
	CompletedSwap: {
		recordId: S.String,
		generation: S.Number,
		result: swapCard.Result,
	},
	CompletedTrack: {},
	CompletedFetchRecent: { generation: S.Number, result: getRecords.Result },
	GotPickerMessage: { message: Picker.Message },
	GotAddEntryMessage: { message: AddEntry.Message },
	CompletedAddEntries: {
		nodeId: S.String,
		/** Echoed so success can tell whether the draft changed while the save was in flight. */
		request: AddEntry.Request,
		generation: S.Number,
		result: S.Result(S.Array(Entry), ApiError),
	},
	/** `FocusEditor` and `SetEditorText` settle here. */
	CompletedEditorAction: {},
});
export type Message = typeof Message.Type;
